import React from 'react';
import { Card, Button } from 'react-bootstrap';

const Confirmation = ({ data, onNewQuote }) => {
  return (
    <div className="p-4 ">
      <Card.Body>
        <h4 style={{ color: '#0d6efd' }}>¡Solicitud Recibida!</h4>
        <p className="text-muted mt-3">
          Hemos recibido tu solicitud de cotización.
        </p>
        <p className="mt-2 mb-4">
          <strong>La cotización fue enviada a:</strong> {data.client?.email || 'correo no disponible'}
        </p>
        <p className="mt-4">
          <strong>Resumen de la Solicitud:</strong>
        </p>
        <ul className="list-unstyled text-start mx-auto">
          <li><strong>Cliente:</strong> {data.client?.name}</li>
          <li><strong>Aplicación:</strong> {data.service?.application}</li>
          <li><strong>Plan:</strong> {data.service?.plan?.id} - {data.service?.plan?.friendlyName}</li>
          <li><strong>Gestión de Firma:</strong> {data.signature?.includeSignatureService ? 'Sí' : 'No'}</li>
        </ul>
        <div className="d-flex justify-content-center mt-4">
          <Button variant="primary" onClick={onNewQuote}>
            Nueva cotización
          </Button>
        </div>
        <hr />
        <p>
          En unos momentos enviaremos nuestra cotización personalizada a tu correo electrónico. Si tienes alguna pregunta mientras tanto, no dudes en contactarnos.
        </p>
        <p>
          Cuando recibamos tu confirmación, a través del pago de la cotización, recibirás en tu correo:<br/>
          <ul>
            <li>Confirmación de creación de la cuenta y primeros pasos, si aún no tienes una cuenta.</li>
            <li>Formulario en línea para iniciar el trámite de firma electrónica, si fue solicitada.</li>
            <li>Confirmación de plan de facturación asignado</li>
          </ul>
        </p>
        <p>
          Cuando se complete el proceso de firma electrónica, te notificaremos para que puedas comenzar a emitir tus facturas electrónicas de inmediato.
        </p>
        <p>
          También recibirás tutoriales y un link para agendar una sesión de inducción y/o configuración de la integración si incluimos ese servicio en tu cotización.
        </p>
      </Card.Body>
    </div>
  );
};

export default Confirmation;
